import {useEffect, useRef} from "react";

import {
    hitGtmHomeMatchBasicFlowEditPreferences,
    hitGtmHomeMatchBasicFlowModal,
    hitGtmHomeMatchBasicFlowToggle
} from "../tracking/home_match_basic_flow_gtm_events";
import type {IHomeMatchBasicPreferencesFlowTrackingContext} from "../types/HomeMatchBasicPreferencesFlowTypes";

interface IUseHomeMatchBasicSummaryGtmTrackingParams {
    isOpen: boolean;
    homeMatchBasicConsent: boolean;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    onClose: () => void;
    onConfirm: () => void;
    onEditPreferences: () => void;
    onHomeMatchBasicConsentChange: (value: boolean) => void;
}

export const useHomeMatchBasicSummaryGtmTracking = (params: IUseHomeMatchBasicSummaryGtmTrackingParams) => {
    const {isOpen, homeMatchBasicConsent, trackingContext, onClose, onConfirm, onEditPreferences, onHomeMatchBasicConsentChange} = params;
    const wasViewTracked = useRef(false);

    useEffect(() => {
        if (!isOpen) {
            wasViewTracked.current = false;
            return;
        }

        if (trackingContext && !wasViewTracked.current) {
            wasViewTracked.current = true;
            hitGtmHomeMatchBasicFlowModal({
                ...trackingContext,
                eventAction: "view",
                homeMatchBasicConsent
            });
        }
    }, [homeMatchBasicConsent, isOpen, trackingContext]);

    const handleClose = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowModal({
                ...trackingContext,
                eventAction: "close",
                homeMatchBasicConsent
            });
        }

        onClose();
    };

    const handleConfirm = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowModal({
                ...trackingContext,
                eventAction: "submit",
                homeMatchBasicConsent
            });
        }

        onConfirm();
    };

    const handleEditPreferences = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowEditPreferences(trackingContext);
        }

        onEditPreferences();
    };

    const handleHomeMatchBasicConsentChange = (value: boolean) => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowToggle({
                ...trackingContext,
                isEnabled: value
            });
        }

        onHomeMatchBasicConsentChange(value);
    };

    return {
        handleClose,
        handleConfirm,
        handleEditPreferences,
        handleHomeMatchBasicConsentChange
    };
};
import {useEffect, useRef} from "react";

import {
    hitGtmHomeMatchBasicFlowEditPreferences,
    hitGtmHomeMatchBasicFlowModal,
    hitGtmHomeMatchBasicFlowToggle
} from "../tracking/home_match_basic_flow_gtm_events";
import type {IHomeMatchBasicPreferencesFlowTrackingContext} from "../types/HomeMatchBasicPreferencesFlowTypes";

interface IUseHomeMatchBasicSummaryGtmTrackingParams {
    isOpen: boolean;
    homeMatchBasicConsent: boolean;
    trackingContext?: IHomeMatchBasicPreferencesFlowTrackingContext;
    onClose: () => void;
    onConfirm: () => void;
    onEditPreferences: () => void;
    onHomeMatchBasicConsentChange: (value: boolean) => void;
}

export const useHomeMatchBasicSummaryGtmTracking = (params: IUseHomeMatchBasicSummaryGtmTrackingParams) => {
    const {isOpen, homeMatchBasicConsent, trackingContext, onClose, onConfirm, onEditPreferences, onHomeMatchBasicConsentChange} = params;
    const wasViewTracked = useRef(false);

    useEffect(() => {
        if (!isOpen) {
            wasViewTracked.current = false;
            return;
        }

        if (trackingContext && !wasViewTracked.current) {
            wasViewTracked.current = true;
            hitGtmHomeMatchBasicFlowModal({
                ...trackingContext,
                eventAction: "view",
                homeMatchBasicConsent
            });
        }
    }, [homeMatchBasicConsent, isOpen, trackingContext]);

    const handleClose = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowModal({
                ...trackingContext,
                eventAction: "close",
                homeMatchBasicConsent
            });
        }

        onClose();
    };

    const handleConfirm = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowModal({
                ...trackingContext,
                eventAction: "submit",
                homeMatchBasicConsent
            });
        }

        onConfirm();
    };

    const handleEditPreferences = () => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowEditPreferences(trackingContext);
        }

        onEditPreferences();
    };

    const handleHomeMatchBasicConsentChange = (value: boolean) => {
        if (trackingContext) {
            hitGtmHomeMatchBasicFlowToggle({
                ...trackingContext,
                isEnabled: value
            });
        }

        onHomeMatchBasicConsentChange(value);
    };

    return {
        handleClose,
        handleConfirm,
        handleEditPreferences,
        handleHomeMatchBasicConsentChange
    };
};
